import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Github, Mail } from 'lucide-react';
import { cx, focusRing } from '../ds/classes';
import { Brand } from './Logo';

const footerLink = cx(
  'inline-flex items-center min-h-target-min font-text text-small text-ink-soft no-underline rounded-radius-sm hover:text-amber',
  focusRing
);

const COLUMNS = [
  { title: 'Product', links: [{ to: '/sonic-insight', label: 'Sonic Insight' }, { to: '/products', label: 'All products' }] },
  { title: 'Company', links: [{ to: '/about', label: 'About' }, { to: '/terms', label: 'Terms of service' }] },
];

const SOCIAL = [
  { icon: Twitter, href: 'https://x.com/theprodfriend', label: 'The Producer\'s Friend on X' },
  { icon: Github, href: 'https://github.com/ArmisDev', label: 'Armis on GitHub' },
  { icon: Mail, href: 'mailto:armisofficialdev@gmail.com', label: 'Email us' },
];

/** The site footer, below every page except the clip workspace */
export const SiteFooter = () => (
  <footer className="bg-chrome text-ink font-text">
    <div className="max-w-[1200px] mx-auto px-space-4 sm:px-space-6 pt-space-10 pb-space-8 flex flex-col gap-space-8">
      <div className="flex flex-wrap justify-between gap-space-8">
        <div className="flex flex-col gap-space-3 max-w-[360px]">
          <Brand />
          <p className="m-0 text-small text-ink-soft">
            A second pair of ears for hobby and bedroom producers: what's working in your mix, and what to fix next.
          </p>
          <div className="flex gap-space-1 -ml-space-3">
            {SOCIAL.map(({ icon: Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target={href.startsWith('http') ? '_blank' : undefined}
                rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
                aria-label={label}
                className={cx('w-target-min h-target-min inline-flex items-center justify-center rounded-radius-md text-muted hover:bg-raised hover:text-ink', focusRing)}
              >
                <Icon size={20} strokeWidth={2.5} aria-hidden="true" />
              </a>
            ))}
          </div>
        </div>
        <div className="flex flex-wrap gap-space-14">
          {COLUMNS.map((column) => (
            <nav key={column.title} aria-label={column.title} className="flex flex-col">
              <span className="text-label text-muted mb-space-1">{column.title}</span>
              {column.links.map((link) => <Link key={link.to} to={link.to} className={footerLink}>{link.label}</Link>)}
            </nav>
          ))}
        </div>
      </div>
      <div className="pt-space-6 border-t border-raised flex flex-wrap justify-between gap-space-3 text-caption text-muted">
        <span>© {new Date().getFullYear()} The Producer's Friend. Made by Armis.</span>
        <span>Sonic Insight gives guidance, not guarantees. Trust your ears.</span>
      </div>
    </div>
  </footer>
);
